// extracted by css-extract-rspack-plugin
export default {"YoutubePlayer":"c4ih4hNLiAfRgUth"};